import React, { useEffect, useState } from 'react';
import {
  differenceInSeconds,
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
} from 'date-fns';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';

import discountBG from '../../assets/img/newsletter/discount-bg.jpg';

const DiscountTwo = () => {
  // Initialize Countdown
  const targetDate = new Date('2025-06-01T00:00:00');
  const calculateTimeLeft = () => {
    const now = new Date();
    const timeLeft = {
      days: differenceInDays(targetDate, now),
      hours: differenceInHours(targetDate, now) % 24,
      minutes: differenceInMinutes(targetDate, now) % 60,
      seconds: differenceInSeconds(targetDate, now) % 60,
    };

    return timeLeft;
  };
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft]);

  const items = [
    { countdownTimeLeft: timeLeft.days, countdownTitle: 'Days' },
    { countdownTimeLeft: timeLeft.hours, countdownTitle: 'Hours' },
    { countdownTimeLeft: timeLeft.minutes, countdownTitle: 'Minutes' },
    { countdownTimeLeft: timeLeft.seconds, countdownTitle: 'Seconds' },
  ];

  return (
    <div
      id="it-discount"
      className="it-discount-area it-discount-bg"
      style={{ backgroundImage: `url(${discountBG})` }}
    >
      <div className="container">
        <div className="row">
          <div className="col-xxl-5 col-xl-7 col-lg-7">
            <div className="it-discount-2-content">
              <h2 className="it-section-title pb-20">
                UP to 40% discount on purchase
              </h2>
              <div className="it-discount-2-text pb-15">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed{' '}
                  <br /> do eiusmod tempor incididunt ut
                </p>
              </div>
              <div className="it-discount-2-timer-box mb-30">
                <div className="row gx-30">
                  {items.map((item, index) => (
                    <div
                      key={index}
                      className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3"
                    >
                      <div className="d-flex justify-content-start justify-content-lg-center align-items-center">
                        <div className="it-discount-2-timer text-center">
                          <h6>{item.countdownTimeLeft}</h6>
                          <i>{item.countdownTitle}</i>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <Link className="it-btn-theme" to="/cart">
                <Button btnText="Shop Now" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountTwo;
